"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.group = void 0;
const group = ({ id, uniqueKey, title, content, subtitle, repeatable = false, }) => {
    return {
        id,
        uniqueKey,
        title,
        content: content.flat(Infinity),
        subtitle,
        repeatable,
    };
};
exports.group = group;
